const FETCH_USER_PROFILE_SUCCESS = "FETCH_USER_PROFILE_SUCCESS";
const CLEAR_USER_PROFILE_SUCCESS = "CLEAR_USER_PROFILE_SUCCESS";

export default {
  FETCH_USER_PROFILE_SUCCESS,
  CLEAR_USER_PROFILE_SUCCESS,
};
